export const GUESTS_ROLES = {
  nonresident: 'nonresident',
  resident: 'resident',
  staff: 'staff',
};
